import { APP_SECRET_TOKEN, CUSTOM_HEADER } from './apiSecurity';

/**
 * Custom fetch wrapper that includes the security token
 */
export async function secureFetch(url: string, options: RequestInit = {}) {
  const headers = {
    ...options.headers,
    [CUSTOM_HEADER]: APP_SECRET_TOKEN,
    'Content-Type': 'application/json',
  };

  return fetch(url, {
    ...options,
    headers,
  });
}

/**
 * Helper for POST requests
 */
export async function securePost(url: string, data: any) {
  return secureFetch(url, {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

/**
 * Helper for GET requests
 */
export async function secureGet(url: string) {
  return secureFetch(url, {
    method: 'GET',
  });
}
